import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  analyticComponents: null,
  analytics: null,
  analyticFeatures: null,
  analyticRiskScores: null,
}

const getters = {
  analyticComponents() {
    return axios.get('/AnalyticComparison/Components')
  },
  analytics() {
    return axios.get('/AnalyticComparison/Analytics')
  },
  analyticFeatures() {
    return axios.get('/AnalyticComparison/Features')
  },
  analyticRiskScores() {
    return axios.get('/AnalyticComparison/SubResults')
  },
}

export default class AnalyticComparisonService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
